module.exports = __webpack_public_path__ + "static/img/kefon_logo_en.b03b242.png";


//////////////////
// WEBPACK FOOTER
// ./static/kefon_logo_en.png
// module id = Cj2N
// module chunks = 1